import { render, staticRenderFns } from "./SupportBlocks.vue?vue&type=template&id=7826aa18&scoped=true"
import script from "./SupportBlocks.vue?vue&type=script&lang=js"
export * from "./SupportBlocks.vue?vue&type=script&lang=js"
import style0 from "./SupportBlocks.vue?vue&type=style&index=0&id=7826aa18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7826aa18",
  null
  
)

export default component.exports